module.exports = __webpack_public_path__ + "img/Z81_08.a058459b.jpg";